import { Component } from "@angular/core";

/**
 * Página dedicada que se muestra cuando el usuario tiene una sesión activa
 * en otro dispositivo. Renderiza el componente de conflicto, que contiene
 * el timer hasta la expiración natural.
 */
@Component({
  selector: "app-conflicto-sesion-page",
  template: `
    <app-conflicto-sesion
      [isLoading]="false"
      [isError]="true"
      [showCloseSessionsButton]="true"
      [statusMessage]="'Este usuario ya tiene una sesión activa en otro dispositivo.'"
    ></app-conflicto-sesion>
  `,
})
export class ConflictoSesionPageComponent {}
